export const LOGIN_POPUP = 'LOGIN_POPUP';
export const LOGIN_BTN = 'LOGIN_BTN';